import React, { useEffect, useState } from "react";
import {
  ImageItem,
  Spinner,
  Submenu,
  AddDecorationButton,
  Containerframes,
} from "./SidebarStyles";
import applyFilterToImages from "../Frames/applyFilterToImages";
import { usePhotos } from "../../Redux/PhotosContext.js";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import styled from "styled-components";
const CheckedIcon = styled.div`
  position: absolute;
  top: 23px;
  left: 25px; /* Adjust as needed */
  z-index: 10; /* Ensure the icon is above the image */
  color: rgba(0, 0, 0, 0.5);
`;
const FrameSubmenu = ({
  isVisible,
  photos,
  selectedPhotos,
  setAllPhotos,
  setLoadingPhotoIds,
  setAcceptedPhotos,
  originalImages,
  setOriginalImages,
  originalImagesLogo,
  setOriginalImagesLogo,
  logo,
}) => {
  const { allFrames, loadingFrames: loading, fetchFrames } = usePhotos();

  const [selectedFrameId, setSelectedFrameId] = useState(null); // Track selected frame
  useEffect(() => {
    if (isVisible && allFrames.length === 0 && !loading) {
      fetchFrames();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, allFrames]);

  if (!isVisible) return null;

  const handleImageClick = (frameId) => {
    setSelectedFrameId((prevId) => (prevId === frameId ? null : frameId)); // Toggle selection
  };

  return (
    <>
      <Containerframes>
        <Submenu style={{ height: "300px" }}>
          {loading ? (
            <Spinner message="Loading frames..." /> // Enhanced loading message
          ) : allFrames.length > 0 ? (
            <>
              {allFrames.map((frame) => (
                <div key={frame.id} style={{ position: "relative" }}>
                  {frame.filters.preview ? (
                    <>
                      {selectedFrameId === frame.id && (
                        <CheckedIcon>
                          <CheckBoxIcon
                            onClick={() => handleImageClick(frame.id)}
                            sx={{ transform: "scale(1.4)" }}
                          />
                        </CheckedIcon>
                      )}
                      <ImageItem
                        src={frame.filters.preview.image}
                        alt={`Frame ${frame.id} Preview`}
                        onClick={() => handleImageClick(frame.id)}
                        style={{
                          filter:
                            selectedFrameId === frame.id ? "blur(1px)" : "none", // Apply blur only when selected
                        }}
                      />
                    </>
                  ) : (
                    <p>No preview available</p>
                  )}
                </div>
              ))}
            </>
          ) : (
            <p>No frames available</p>
          )}
        </Submenu>
        <AddDecorationButton
          disabled={!selectedFrameId}
          onClick={() =>
            applyFilterToImages(
              selectedFrameId,
              allFrames,
              photos,
              setAllPhotos,
              selectedPhotos,
              originalImages,
              originalImagesLogo,
              setOriginalImagesLogo,
              setLoadingPhotoIds,
              setAcceptedPhotos,
              logo
            )
          }
        >
          Add Decoration
        </AddDecorationButton>
      </Containerframes>
    </>
  );
};

export default FrameSubmenu;
